export const DATA_GRID_STATE_KEY = 'nutrisense:coachesBilling:details:dataGrid:state'
